import React, { useState, useRef } from 'react';
import type { ReactElement } from 'react';
import OnboardingFormComponent, {
  type OnboardingForm
} from '../components/OnboardingForm';
import { sendOnboardingForm } from '../../common/api-client';
import { useAuthContext } from '../../common/contexts/auth';
import { useGlobalToast } from '../../common/contexts/globalToast';
import { useTranslation } from 'react-i18next';
import { Loader } from '@deque/cauldron-react';

const OnboardingForm = (): ReactElement => {
  const { user, loading } = useAuthContext();
  const { setContents } = useGlobalToast();
  const { t } = useTranslation();
  const loaderRef = useRef<HTMLDivElement>(null);

  const [submitting, setSubmitting] = useState(false);

  const onSubmitForm = async (data: OnboardingForm) => {
    try {
      setSubmitting(true);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      await sendOnboardingForm(user!.token, data);
      setContents(
        t(
          'Form was successfully submitted. You should receive your custom implementation documentation in next 3-5 business days'
        ),
        'confirmation'
      );
    } catch (error) {
      setContents(t('Error sending onboarding form'), 'error');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <Loader label={t('Loading')} tabIndex={-1} ref={loaderRef} />;
  }

  return (
    <OnboardingFormComponent onSubmit={onSubmitForm} submitting={submitting} />
  );
};

export default OnboardingForm;
